import { useMutation } from "@tanstack/react-query";
import api from "../api"; // your axios instance

// ==============================
// 1️⃣ Generate OTP
// ==============================
export interface GenerateOtpRequest {
  receiver_id: string | number;
  purpose: "sign up" | "reset password";
  country_code: string;
}

export interface GenerateOtpResponse {
  statusCode: number;
  message: string;
  data: {
    user_id(user_id: any): unknown;
    otp_verification_id: number;
  };
}

export const useGenerateOtp = () =>
  useMutation<GenerateOtpResponse, Error, GenerateOtpRequest>({
    mutationFn: async (payload) => {
      const { data } = await api.post<GenerateOtpResponse>(
        "/send-otp/v1",
        payload
      );
      return data;
    },
  });

// ==============================
// 2️⃣ Verify OTP
// ==============================
export interface VerifyOtpRequest {
  otp_verification_id: number;
  otp: string | number;
}

export interface VerifyOtpResponse {
  statusCode: number;
  message: string;
}

export const useVerifyOtp = () =>
  useMutation<VerifyOtpResponse, Error, VerifyOtpRequest>({
    mutationFn: async (payload) => {
      const { data } = await api.post<VerifyOtpResponse>(
        "/verify-otp/v1",
        payload
      );
      return data;
    },
  });

// ==============================
// 3️⃣ Reset Password
// ==============================
export interface ResetPasswordRequest {
  user_id: string;
  password: string;
}

export interface ResetPasswordResponse {
  statusCode: number;
  message: string;
}

export const useResetPassword = () =>
  useMutation<ResetPasswordResponse, Error, ResetPasswordRequest>({
    mutationFn: async (payload) => {
      const { data } = await api.post<ResetPasswordResponse>(
        "/reset-password/v1",
        payload
      );
      return data;
    },
  });
